<template>
  <div class="h-full w-full">
    <div class="w-full pb-2 fixed top-12 bg-brand_sub h-22 px-2 z-10">
      <div class="py-2 font-bold bg-brand_sub" @click="closeForm">
        <div class="float-left"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg></div>
        <div>戻る</div>
      </div>
      <search-form
        ref="searchForm"
        @incrementSearch="onIncrementSearch"
        @clearForm="clearForm"
        :value="searchWord"
        :isStationOnly="isStationOnly"
      />
    </div>
    <div v-if="searchWord !== undefined && searchWord.length > 0" class="px-2 mt-24">
      <search-result
        @openPlace="onOpenPlace"
        :searchWord="searchWord"
        :isStationOnly="isStationOnly"
      />
    </div>
    <div v-else class="px-2 mt-24">
      <history @openPlace="onOpenPlace" class="mt-4" :isStationOnly="isStationOnly" />
    </div>
  </div>
</template>

<script>
import SearchForm from './SearchForm'
import History from './History'
import SearchResult from './SearchResult'

export default {
  components: {
    SearchForm,
    History,
    SearchResult
  },
  props: {
    isStationOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchWord: ''
    }
  },
  methods: {
    onOpenPlace: function (place) {
      this.$emit('setSearch', place)
    },
    onMyLocation: function () {
      this.$emit('clearForm')
      this.$emit('closeSearchPanel')
    },
    onIncrementSearch: function (word) {
      this.searchWord = word
    },
    setForm: function (place) {
      if (place !== '') {
        this.searchWord = place.name
      }
      this.$refs.searchForm.setFocus()
    },
    clearForm: function () {
      this.searchWord = ''
    },
    closeForm: function () {
      this.$emit('closeSearchPanel')
    }
  }
}
</script>
